module.exports = __webpack_public_path__ + "img/pauseImage.45d8f006.png";